var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "rule_page" },
      on: {
        click: function($event) {
          _vm.closeMenu()
        }
      }
    },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("利用規約")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [_c("dd-user-rule-detial", { attrs: { isConstruct: false } })],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9426e56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9426e56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcUseRule.vue
// module id = null
// module chunks = 